var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-box-alt",
    clipPath: "url(#clip0_19014_17768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.83333 3.5V0H8.16667V3.5C8.16667 3.80942 8.04375 4.10617 7.82496 4.32496C7.60616 4.54375 7.30942 4.66667 7 4.66667C6.69058 4.66667 6.39383 4.54375 6.17504 4.32496C5.95625 4.10617 5.83333 3.80942 5.83333 3.5ZM9.33333 2.91667H14C13.9991 2.1434 13.6915 1.40208 13.1447 0.855295C12.5979 0.308514 11.8566 0.00092625 11.0833 0L9.33333 0V2.91667ZM4.66667 0H2.91667C2.1434 0.00092625 1.40208 0.308514 0.855295 0.855295C0.308514 1.40208 0.00092625 2.1434 0 2.91667H4.66667V0ZM14 4.08333V11.0833C13.9991 11.8566 13.6915 12.5979 13.1447 13.1447C12.5979 13.6915 11.8566 13.9991 11.0833 14H2.91667C2.1434 13.9991 1.40208 13.6915 0.855295 13.1447C0.308514 12.5979 0.00092625 11.8566 0 11.0833L0 4.08333H4.7495C4.87682 4.58359 5.1672 5.02716 5.57475 5.34398C5.9823 5.66079 6.48379 5.83279 7 5.83279C7.51621 5.83279 8.0177 5.66079 8.42525 5.34398C8.8328 5.02716 9.12317 4.58359 9.2505 4.08333H14ZM11.6667 11.0833C11.6667 10.9286 11.6052 10.7802 11.4958 10.6709C11.3864 10.5615 11.238 10.5 11.0833 10.5H9.33333C9.17862 10.5 9.03025 10.5615 8.92085 10.6709C8.81146 10.7802 8.75 10.9286 8.75 11.0833C8.75 11.238 8.81146 11.3864 8.92085 11.4958C9.03025 11.6052 9.17862 11.6667 9.33333 11.6667H11.0833C11.238 11.6667 11.3864 11.6052 11.4958 11.4958C11.6052 11.3864 11.6667 11.238 11.6667 11.0833Z",
    fill: "#329189"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19014_17768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.46b027a5261655b851cf5d27871f2d72.svg";
export { ForwardRef as ReactComponent };